import { createCardPictureCtaComponent } from '@vfde-brix/card-picture-cta';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

export const mountCardPicture = () => {
    const elements = document.getElementsByClassName('brix-card-picture-cta');

    for (let i = 0, x = elements.length; i < x; i += 1) {

        createCardPictureCtaComponent(elements[i], NO_PATTERN_BUSINESS_LOGIC);
    }
}
